module.exports = __webpack_public_path__ + "img/reward.29fad32a.svg";